import { UsersContainer } from "../containers/users"

export const Users = () => {
    return (
        <UsersContainer />
    )
}